export default __webpack_public_path__ + "static/Yuniar Linda-bf134d11d39a614fee2d3b406e700178.jpg";